import React, { useCallback, useState } from 'react';
import type { ReactNode } from 'react';
import {
  CONSENT_KEY,
  CookieConsentContext,
  readStoredConsent,
  type ConsentStatus,
} from './cookieConsentContext';

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const [consentStatus, setConsentStatus] = useState<ConsentStatus>(() => readStoredConsent());

  const persistConsent = useCallback((status: 'accepted' | 'rejected') => {
    try {
      localStorage.setItem(CONSENT_KEY, status);
    } catch {
      // ignore
    }
    setConsentStatus(status);
  }, []);

  const acceptAnalytics = useCallback(() => {
    persistConsent('accepted');
  }, [persistConsent]);

  const rejectAnalytics = useCallback(() => {
    persistConsent('rejected');
  }, [persistConsent]);

  const setAnalyticsConsent = useCallback(
    (value: boolean) => {
      persistConsent(value ? 'accepted' : 'rejected');
    },
    [persistConsent]
  );

  const hasAnalyticsConsent = consentStatus === 'accepted';

  const value = {
    consentStatus,
    hasAnalyticsConsent,
    acceptAnalytics,
    rejectAnalytics,
    setAnalyticsConsent,
  };

  return (
    <CookieConsentContext.Provider value={value}>
      {children}
    </CookieConsentContext.Provider>
  );
}
